import { render, staticRenderFns } from "./AddTenant.vue?vue&type=template&id=16c1465a&"
import script from "./AddTenant.vue?vue&type=script&lang=js&"
export * from "./AddTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports